import React, { useState } from "react";
import authoring_icon from "../img/operationMenu_icons/gestalten.svg";
import effects_icon from "../img/operationMenu_icons/auslosen.svg";
import read_aloud_icon from "../img/operationMenu_icons/vorlesen.svg";
import record_icon from "../img/operationMenu_icons/aufnehmen.svg";
import word_clarification_icon from "../img/operationMenu_icons/sammeln.svg";
import word_wall_icon from "../img/operationMenu_icons/entdecken.svg";
import word_edit_story from "../img/word-edit-story.png";
import opMenu_fab_close_icon from "../img/operationMenu_icons/opMenu_fab_close.svg";
import opMenu_fab_open_icon from "../img/operationMenu_icons/opMenu_fab_open.svg";

import { useTranslation } from "react-i18next";
import streenTheme from "../css/theme.scss";
import { AppstoreOutlined, CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
// Operation modes enum
import { OPERATION_MODES } from "../config/operationModes";

const OperationsMenu = ({
  setNavToGestaltenPage,
  selectedOperation,
  onSelectOperation,
  isEditing,
  setIsEditing,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIcons = {
    authoring: authoring_icon,
    effects: effects_icon,
    read_aloud: read_aloud_icon,
    record: record_icon,
    highlight: word_clarification_icon,
    word_clarification: word_clarification_icon,
    word_cloud: word_wall_icon,
    edit: word_edit_story,
  };

  useTranslation();

  return (
    
      <>
      {isOpen && (
      <div className="operations-menu-wrapper">
        <div className="operations-menu show">
          <button
            onClick={() => {
              //showMessage("Nicht verfügbar");
              onSelectOperation(OPERATION_MODES.AUSLOSEN);
              setIsOpen(false);
            }}
            className={`operation-button ${
              selectedOperation === OPERATION_MODES.AUSLOSEN ? "selected" : ""
            }`}
            disabled={selectedOperation === OPERATION_MODES.AUSLOSEN}
          >
            <div className="button-content">
              <img src={effects_icon} alt="" />
              <br></br>
              <span>Auslösen</span>
            </div>
          </button>

      <button
        onClick={() => {
          onSelectOperation(OPERATION_MODES.GESTALTEN);
          setNavToGestaltenPage(true);
          setIsOpen(false);
        }}
        className={`operation-button ${
          selectedOperation === OPERATION_MODES.GESTALTEN ? "selected" : ""
        }`}
        // disabled={selectedOperation === "authoring"}
      >
        <div className="button-content">
          <img src={authoring_icon} alt="" />
          <br></br>
          <span>Gestalten</span>
        </div>
      </button>

      <button
        onClick={() => {
          // showMessage("Nicht verfügbar");
          onSelectOperation(OPERATION_MODES.VORLESEN);
          setIsOpen(false);
        }}
        className={`operation-button ${
          selectedOperation === OPERATION_MODES.VORLESEN ? "selected" : ""
        }`}
        disabled={selectedOperation === OPERATION_MODES.VORLESEN}
      >
        <div className="button-content">
          <img src={read_aloud_icon} alt="" />
          <br></br>
          <span>Vorlesen</span>
        </div>
      </button>

      <button
        onClick={() => {
          // showMessage("Nicht verfügbar");
          onSelectOperation(OPERATION_MODES.AUFNEHMEN);
          setNavToGestaltenPage(true);
          setIsOpen(false);
        }}
        className={`operation-button ${
          selectedOperation === OPERATION_MODES.AUFNEHMEN ? "selected" : ""
        }`}
        disabled={selectedOperation === OPERATION_MODES.AUFNEHMEN}
      >
        <div className="button-content">
          <img src={record_icon} alt="" />
          <br></br>
          <span>Aufnehmen</span>
        </div>
      </button>
      {/* <button
        onClick={() => {
          //  showMessage("Nicht verfügbar");
             onSelectOperation(OPERATION_MODES.ENTDECKEN);
             setIsOpen(false);
        }}
        className={`operation-button ${
          selectedOperation === OPERATION_MODES.ENTDECKEN ? "selected" : ""
        }`}
        disabled={selectedOperation === OPERATION_MODES.ENTDECKEN}
      >
        <div className="button-content">
          <img src={word_clarification_icon} alt="" />
          <br></br>
          <span>Sammeln</span>
        </div>
      </button> */}
      <button
        onClick={() => {
          // showMessage("Nicht verfügbar");
         onSelectOperation(OPERATION_MODES.SAMMELN)
          setIsOpen(false);
        }}
        className={`operation-button ${
          selectedOperation === OPERATION_MODES.SAMMELN ? "selected" : ""
        }`}
      >
        <div className="button-content">
          <img src={word_clarification_icon} alt="" />
          <br></br>
          <span>Sammeln</span>
        </div>
      </button>
      <button
        onClick={() => {
          // showMessage("Nicht verfügbar");
          onSelectOperation("word_cloud");
          setIsOpen(false);
        }}
        className={`operation-button ${
          selectedOperation === "word_cloud" ? "selected" : ""
        }`}
        disabled={selectedOperation === "word_cloud"}
      >
        <div className="button-content">
          <img src={word_wall_icon} alt="" />
          <br></br>
          <span>Entdecken</span>
        </div>
      </button>

      
     
      {/* <button
        onClick={() => {
          showMessage("Nicht verfügbar");
           // onSelectOperation(OPERATION_MODES.EDIT);
            //setIsEditing(!isEditing);
            setIsOpen(false);
        }}
        className={`operation-button ${
          selectedOperation === OPERATION_MODES.EDIT ? "selected" : ""
        }`}
      >
        <div className="button-content">
          {selectedOperation === OPERATION_MODES.EDIT ? (
            <img src={word_edit_story} alt="" />
          ) : (
            <img src={word_edit_story} alt="" />
          )}
          <br></br>
          <span>Editiere</span>
        </div>
      </button> */}
        
        
        
        </div>
      </div>
        
  
    
        )
      } 
      <Button
    className={`fab-button ${isOpen ? "selected" : ""}`}
    onClick={() => setIsOpen(prev => !prev)}
   
>
        {isOpen ? 
          <img
            src={opMenu_fab_open_icon}            
            alt=""
            style={{
              width: 29,
              height: 29,
            }}
          /> 
        : 
          selectedOperation ? 
            <img
              src={toggleIcons[selectedOperation]}
              alt={selectedOperation}
              style={{
                width: 29,
                height: 29,
              }}
            /> : <img
                  src={opMenu_fab_open_icon}
                  alt=""
                  style={{
                    width: 29,
                    height: 29,
                  }}
                /> 
            }
                      
        </Button>
      </>
    )
  };

export  default OperationsMenu;
